import bsCustomFileInput from 'bs-custom-file-input';
import 'arrive';
import $ from 'jquery';

document.arrive('.wpcf7 .custom-file', {existing: true}, function(){
    console.log('bsCustomFileInput.init();');
    const input = this.querySelector('input[type="file"]');
    const label = this.querySelector('.custom-file-label');
    const labelDefault = label.innerHTML;
    bsCustomFileInput.init();
    $(input).on('change', function(){
       const file = input.files[0];

       if (file) {
          label.innerHTML = file.name;
       } else {
            label.innerHTML = labelDefault;
       }
    });
});